import { FC, useEffect, useState } from 'react';
import { Input } from 'antd';
import { TbFilterPlus } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { EmptySection, VirtualizedList as List } from '@/shared';
import { BaseSkeleton } from '@/shared/components/skeletons';
import { useCustomFilterStore } from '@/stores';
import { CustomFilter } from '@/types';

import CustomFilterListItem from './CustomFilterListItem';

const CustomFilters: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();

    const [searchInput, setSearchInput] = useState<string>('');

    const { fetchCustomFilters, customFilters, loading } = useCustomFilterStore();

    useEffect(() => {
        fetchCustomFilters();
    }, []);

    let searchedCustomFilters: CustomFilter[];

    if (searchInput !== '') {
        searchedCustomFilters = customFilters.filter((i) => {
            return (
                // prettier-ignore
                String(i?.title)?.toLowerCase().includes(String(searchInput)?.toLowerCase()) ||
                    String(i?.description)?.toLowerCase().includes(String(searchInput)?.toLowerCase())
            );
        });
    } else {
        searchedCustomFilters = customFilters;
    }

    return (
        <>
            <div>
                <small style={{ color: token.colorTextTertiary }}>Custom Filters ({customFilters?.length})</small>
            </div>
            <Input
                placeholder='Search Custom Filters...'
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                style={{ marginTop: '0.75rem' }}
            />
            {searchedCustomFilters?.length !== 0 && !loading ? (
                <>
                    <List
                        dataSource={searchedCustomFilters}
                        renderItem={(i) => {
                            return <CustomFilterListItem i={i} />;
                        }}
                    />
                </>
            ) : loading ? (
                <BaseSkeleton active round title paragraph={{ rows: 24 }} />
            ) : (
                <EmptySection
                    height='15rem'
                    icon={<TbFilterPlus size='75%' />}
                    label={searchInput.trim() ? 'No Matching Custom Filters' : 'No Custom Filters'}
                    description={
                        searchInput.trim()
                            ? 'Try a different name or description.'
                            : 'Save applied filters to reuse them across Search.'
                    }
                />
            )}
        </>
    );
};

export default CustomFilters;
